import { createSlice } from '@reduxjs/toolkit';

const initialDeal = {
    bundleDealCache: {}, // Stores cached bundle deals with the API URL as the key
    similarOffers: {}, // Stores cached similar deals with the API URL as the key
    monthOffers: {}, // Stores cached month deals with the API URL as the key
    brandOffers: {}, // Stores cached brand deals with the API URL as the key
    topOffers: {}, // Stores cached top deals with the API URL as the key
    financeOffers: {}, // Stores cached financial deals with the API URL as the key
    externalOffers: {}, // Stores cached external deals with the API URL as the key
    moveInOffers: {}, // Stores cached moveIn deals with the API URL as the key
    benefitsOffers: {}, // Stores cached benefits deals with the API URL as the key
    digitalAmenities: {}, // Stores cached digitalAmenities deals with the API URL as the key
    bundleOffers: {}, // Stores cached bundleOffers deals with the API URL as the key
    isRefreshRewards: false,
    isCartModalVisible: false,
    showRewardsModal:false,
    isKycModalEnabled: false // To open kyc modal
};

const dealsSlice = createSlice({
    name: 'deals',
    initialState: initialDeal,
    reducers: {
        saveBundleDeals(state, action) {
            const { url, deals } = action.payload;
            // Store the bundle deals in the cache with the URL as the key
            state.bundleDealCache[url] = deals;
        },
        clearBundleDealsCache(state) {
            // Clears the entire bundle deal cache
            state.bundleDealCache = {};
        },
        removeBundleDealsByUrl(state, action) {
            const { url } = action.payload;
            // Removes the bundle deals cached for a specific URL
            delete state.bundleDealCache[url];
        },
        saveSimilarDeals(state, action) {
            const { url, deals } = action.payload;
            // Store the similar deals in the cache with the URL as the key
            state.similarOffers[url] = deals;
        },
        clearSimilarDealsCache(state) {
            // Clears the entire similar deal cache
            state.similarOffers = {};
        },
        removeSimilarDealsByUrl(state, action) {
            const { url } = action.payload;
            // Removes the similar deals cached for a specific URL
            delete state.similarOffers[url];
        },
        saveOfferOfMonthDeals(state, action) {
            const { url, deals } = action.payload;
            // Store the month deals in the cache with the URL as the key
            state.monthOffers[url] = deals;
        },
        clearOfferOfMonthDealsCache(state) {
            // Clears the entire month deal cache
            state.monthOffers = {};
        },
        removeOfferOfMonthDealsByUrl(state, action) {
            const { url } = action.payload;
            // Removes the Monthh deal cached for a specific URL
            delete state.monthOffers[url];
        },
        saveSameBrandOffersDeals(state, action) {
            const { url, deals } = action.payload;
            // Store the same brand deals in the cache with the URL as the key
            state.brandOffers[url] = deals;
        },
        clearSameBrandOffersDealsCache(state) {
            // Clears the entire same brand deal cache
            state.brandOffers = {};
        },
        removeSameBrandOffersDealsByUrl(state, action) {
            const { url } = action.payload;
            // Removes the same brand deal cached for a specific URL
            delete state.brandOffers[url];
        },
        saveTopOffersDeals(state, action) {
            const { url, deals } = action.payload;
            // Store the top deals in the cache with the URL as the key
            state.topOffers[url] = deals;
        },
        clearTopOffersDealsCache(state) {
            // Clears the entire top deal cache
            state.topOffers = {};
        },
        removeTopOffersDealsByUrl(state, action) {
            const { url } = action.payload;
            // Removes the  top deal cached for a specific URL
            delete state.topOffers[url];
        },
        saveFinanceOffersDeals(state, action) {
            const { url, deals } = action.payload;
            // Store the financeOffers deals in the cache with the URL as the key
            state.financeOffers[url] = deals;
        },
        clearFinanceOffersDealsCache(state) {
            // Clears the entire financeOffers deal cache
            state.financeOffers = {};
        },
        removeFinanceOffersDealsByUrl(state, action) {
            const { url } = action.payload;
            // Removes the  financeOffers deal cached for a specific URL
            delete state.financeOffers[url];
        },
        saveExternalOffersDeals(state, action) {
            const { url, deals } = action.payload;
            // Store the externalOffers deals in the cache with the URL as the key
            state.externalOffers[url] = deals;
        },
        clearExternalOffersDealsCache(state) {
            // Clears the entire externalOffers deal cache
            state.externalOffers = {};
        },
        removeExternalOffersDealsByUrl(state, action) {
            const { url } = action.payload;
            // Removes the  externalOffers deal cached for a specific URL
            delete state.externalOffers[url];
        },
        saveMoveInOffersDeals(state, action) {
            const { url, deals } = action.payload;
            // Store the moveInOffers deals in the cache with the URL as the key
            state.moveInOffers[url] = deals;
        },
        clearMoveInOffersDealsCache(state) {
            // Clears the entire moveInOffers deal cache
            state.moveInOffers = {};
        },
        removeMoveInOffersDealsByUrl(state, action) {
            const { url } = action.payload;
            // Removes the  moveInOffers deal cached for a specific URL
            delete state.moveInOffers[url];
        },
        saveBenefitsoffersDeals(state, action) {
            const { url, deals } = action.payload;
            // Store the benefitsOffers deals in the cache with the URL as the key
            state.benefitsOffers[url] = deals;
        },
        clearBenefitsOffersDealsCache(state) {
            // Clears the entire benefitsOffers deal cache
            state.benefitsOffers = {};
        },
        removeBenefitsOffersDealsByUrl(state, action) {
            const { url } = action.payload;
            // Removes the  benefitsOffers deal cached for a specific URL
            delete state.benefitsOffers[url];
        },
        saveDigitalAmenitiesDeals(state, action) {
            const { url, deals } = action.payload;
            // Store the digitalAmenities deals in the cache with the URL as the key
            state.digitalAmenities[url] = deals;
        },
        clearDigitalAmenitiessDealsCache(state) {
            // Clears the entire digitalAmenities deal cache
            state.digitalAmenities = {};
        },
        removeDigitalAmenitiesDealsByUrl(state, action) {
            const { url } = action.payload;
            // Removes the  digitalAmenities deal cached for a specific URL
            delete state.digitalAmenities[url];
        },
        saveBundleOffersDeals(state, action) {
            const { url, deals } = action.payload;
            // Store the BundleOffers deals in the cache with the URL as the key
            state.bundleOffers[url] = deals;
        },
        clearBundleOfferssDealsCache(state) {
            // Clears the entire BundleOffers deal cache
            state.bundleOffers = {};
        },
        removeBundleOffersDealsByUrl(state, action) {
            const { url } = action.payload;
            // Removes the  BundleOffers deal cached for a specific URL
            delete state.bundleOffers[url];
        },
        // Clear all Cache
        clearAllCaches(state) {
            state.bundleDealCache = {};
            state.similarOffers = {};
            state.monthOffers = {};
            state.brandOffers = {};
            state.topOffers = {};
            state.financeOffers = {};
            state.externalOffers = {};
            state.moveInOffers = {};
            state.benefitsOffers = {};
            state.digitalAmenities = {};
            state.bundleOffers = {};
        },
        // Action to refresh rewards
        setIsRewardRefreshing(state, action) {
            state.isRefreshRewards = action.payload;
        },
        // Action to set open cart modal
        setCartModalVisible(state, action) {
            state.isCartModalVisible = action.payload;
        },
         // Action to set open Rewardsmodal
         setShowRewardsModal(state, action) {
            state.showRewardsModal = action.payload;
        },
        // Action to set open cart modal
        setKycModalEnabled(state, action) {
            state.isKycModalEnabled = action.payload;
        }
    }
});

export const dealAction = dealsSlice.actions;
export default dealsSlice;
